package com.evoapps.evoshift.domain.usecase.shift

import com.evoapps.evoshift.domain.model.Shift
import com.evoapps.evoshift.domain.repository.ShiftRepository

/**
 * Deletes a shift. Its cost snapshot (shift_financials) is removed by the onShiftDeleted Cloud
 * Function: the person deleting may not be allowed to touch financial data.
 */
class DeleteShiftUseCase(
    private val shiftRepository: ShiftRepository
) {
    suspend operator fun invoke(shiftId: String): Result<Unit> = shiftRepository.deleteShift(shiftId)

    /** SH-169: deletes [shiftIds] in batches (undoing the grid's multi-select or paste). */
    suspend fun many(shiftIds: List<String>): Result<Unit> = shiftRepository.deleteShifts(shiftIds)

    /**
     * SH-263: Undo of a delete: [shift] back under its own id exactly as it was, so a published
     * shift is the team's again and its removal record goes (nothing left to publish for it).
     */
    suspend fun restore(shift: Shift): Result<Unit> = shiftRepository.restoreShifts(listOf(shift))
}
